const IDLE_CONTROL = 'idleControl';
const AUTO_LOAD_CONTROL = 'autoControl';
const AUTO_DOWNLOAD_CONTROL = 'autoDownloadControl';

export {
  IDLE_CONTROL,
  AUTO_LOAD_CONTROL,
  AUTO_DOWNLOAD_CONTROL,
};
